import React from "react";
import styles from "../MarqueeSlider/MarqueeSlider.module.css";
const MarqueeSlider = (props) => {
  const data = props?.banner ?? props;
  const enabled = data?.enabled ?? true;
  const items = data?.items ?? [];
  if (!enabled || !items.length) return null;
  const loop = [...items, ...items];

  return (
    <div className={styles.MarqueeMain}>
      <div className={styles.Marquee}>
        <div className={styles.MarqueeContent}>
          {loop.map((it, i) => {
            const src = it?.image?.src;
            const alt = it?.image?.alt || "";
            const url = it?.url || null;


            
            if (!src) return null;

            const imgEl = <img src={src} alt={alt} loading="lazy" />;

            return (
              <div className={styles.MarqueeTag} key={`${src}-${i}`}>
                {url ? (
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={alt || "logo"}
                  >
                    {imgEl}
                  </a>
                ) : (
                  imgEl
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MarqueeSlider;
